import { RootState } from "../store";

export const selectUser = (state: RootState) => state.auth.user;
export const tokenUser = (state: RootState) => state.auth.token;
export const idUserAccount = (state: RootState) => state.auth.user?.id;
export const verificationToken = (state: RootState) => state.auth?.verificationToken
export const generationQRCode = (state: RootState) => state.auth?.authQRCode;
export const selectIsLoggedIn = (state: RootState) => Boolean(state.auth.token);
export const selectIsRefreshing = (state: RootState) => Boolean(state.auth.isRefreshing);